export const new_jersey = {
  "34000": "New Jersey",
  "34001": "Atlantic County",
  "34003": "Bergen County",
  "34005": "Burlington County",
  "34007": "Camden County",
  "34009": "Cape May County",
  "34011": "Cumberland County",
  "34013": "Essex County",
  "34015": "Gloucester County",
  "34017": "Hudson County",
  "34019": "Hunterdon County",
  "34021": "Mercer County",
  "34023": "Middlesex County",
  "34025": "Monmouth County",
  "34027": "Morris County",
  "34029": "Ocean County",
  "34031": "Passaic County",
  "34033": "Salem County",
  "34035": "Somerset County",
  "34037": "Sussex County",
  "34039": "Union County",
  "34041": "Warren County",
};
